<template>
  <div
    :id="`title-width-line-break${dynamicNumber}`"
    class="section-title ProjectSectionTitleBreak"
    :class="[`small-${content.small_bottom_margin}`,content.mobile_settings, `align-right-${content.align_right}` ]"
    :style="`color : ${customDescColor};background : ${customColor}; ${customGradient}; `"
  >
    <div
      class="inline-for-mobile"
      v-html="content.title_with_line_breaks"
    />
  </div>
</template>

<script>
/* Mixins */
import marked from "@/mixins/marked";

export default {
  mixins: [marked],
  props: {
    content: {
      type: Object,
      default: () => {}
    },
    isProject: {
      type: Boolean
    }
  },

  computed: {
    dynamicNumber() {
      const randomNum = Math.floor(1000 + Math.random() * 9000);
      return randomNum;
    },

    customColor() {
      if (this.content.bg_color) {
        return this.content.bg_color;
      } else {
        return "transparent";
      }
    },

    customGradient() {
      if (this.content.gradient_code) {
        return this.content.gradient_code;
      } else {
        return "";
      }
    },

    customDescColor() {
      if (this.content.color) {
        return this.content.color;
      } else {
        return "#000";
      }
    },

  },
};
</script>

<style lang="scss">
.ProjectSectionTitleBreak {
  max-width: 100vw;
  padding-top: 13vw;
  padding-bottom: 5vw;
  overflow-x: hidden;
  overflow-y: hidden;
  width: 100%;

  * {
    line-height: 1.1;
  }

   strong {
    color: $orange;
  }

  &.align-right-true {
    @include tablet {
      text-align: right;
    }
  }

  .hide {
    display: none;
  }


  @include tablet {
    padding-top: 7.7vw;
    padding-bottom: 1.5vw;
    @include paddingBig;
  }

  &.small-true {
    padding-bottom: 2vw;

    @include tablet {
      padding-bottom: 0.3vw;
    }
  }

  .inline-for-mobile * {

    @media (max-width: 576px) {
      display: inline;
      margin-right: 4px;
    }
  }

  &.hide-mobile {
  display: none;

  @include tablet {
    display: block;
  }

}

}
</style>
